<template>
  <div class="pcTDetail">
    <div class="tDetailLeft">
      <img :src="teamInfo.avatar" alt="">
    </div>
    <div class="tDetailRight">
      <div class="userInfo">
        <div class="name fOH">
          {{ teamInfo.nickname }}
        </div>
        <div class="desc fOR">
          {{ teamInfo.zw_name }}
        </div>
      </div>
      <div class="experience fOb" v-html="teamInfo.desc">
      </div>
      <div class="backInfo" @click="goBack">
        <img src="../../../assets/image/team-bak.png" alt="">
        <div class="text fOR">Back</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    teamInfo(){
      return this.$store.getters.teamInfo
    }
  },
  methods:{
    goBack(){
      this.$emit('goDetail',false)
    }
  }
}
</script>
<style scoped lang="scss">
.pcTDetail{
  box-sizing: border-box;
  width: 100%;
  max-height: 65vh;
  padding: 2rem 2rem 4rem;
  background: linear-gradient(-20deg, rgba(24, 95, 203, .7) 0%, rgba(116, 181, 212, .7) 100%);
  border-radius: 10px;
  display: flex;
  align-items: flex-start;
  position: relative;
  .backInfo{
    position: absolute;
    z-index: 100;
    left: 2rem;
    bottom: 2rem;
    font-size: 1rem;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    img{
      width: 1rem;
      margin-right: .5rem;
    }
  }
  .tDetailRight{
    flex: 2;
    height: 100%;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    margin-left: 2rem;
    //overflow: hidden;
    .userInfo{
      border-bottom: .12rem solid #fff;
      padding-bottom: 1rem;
      color: #fff;
      .name{
        font-size: 1.8rem;
      }
      .desc{
        margin-top: .3rem;
        font-size: 1rem;
      }
    }
    .experience{
      overflow: hidden;
      overflow-y: auto;
      flex: 1;
      padding: 1rem 0;
      color: #fff;
      font-size: .95rem;
      line-height: 1.8rem;
    }
  }
  .tDetailLeft{
    flex: 1.2;
    img{
      width: 100%;
      padding-bottom: 2rem;
    }
  }
}
</style>
